import React from "react";
import {
  FaGoogle,
  FaYelp,
  FaFacebook,
  FaExternalLinkAlt,
} from "react-icons/fa";

const platformConfig = {
  Yelp: {
    icon: FaYelp,
    color: "#D32323",
    bgColor: "bg-red-50",
  },
  Google: {
    icon: FaGoogle,
    color: "#4285F4",
    bgColor: "bg-blue-50",
  },
  Facebook: {
    icon: FaFacebook,
    color: "#1877F2",
    bgColor: "bg-blue-50",
  },
};

const RedirectionModal = ({
  isOpen,
  onClose,
  onContinue,
  service,
  businessName,
  visitDetails,
  visitDetailsLoading,
}) => {
  if (!isOpen) return null;

  const config = platformConfig[service] || platformConfig.Google;
  const Icon = config.icon;

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split("-");
    return new Date(year, month - 1, day).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-x-hidden overflow-y-auto animate-[fadeInUp_0.3s_ease-out] max-h-[90vh]">
        <div className={`${config.bgColor} pt-6 pb-4 px-6 text-center`}>
          <div
            className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-4"
            style={{ backgroundColor: config.color }}
          >
            <Icon size={26} className="text-white" />
          </div>
          <h2 className="text-xl font-bold text-gray-800">
            Loved your visit? Let others know.
          </h2>
          {businessName && (
            <p className="text-sm text-gray-500 mt-1">
              Help others find {businessName}.
            </p>
          )}
        </div>

        <div className="px-6 py-4">
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-3">
              Your Recent Visits
            </p>

            {visitDetailsLoading ? (
              <div className="flex items-center gap-3 py-4">
                <div className="w-4 h-4 border-2 border-gray-200 border-t-gray-500 rounded-full animate-spin shrink-0" />
                <p className="text-sm text-gray-400">Loading your visits...</p>
              </div>
            ) : Array.isArray(visitDetails) && visitDetails.length > 0 ? (
              <div className="space-y-3">
                {visitDetails.map((visit, idx) => (
                  <div
                    key={idx}
                    className="bg-white rounded-xl p-4 border border-gray-100"
                  >
                    <p
                      className="text-xs font-bold tracking-wider uppercase mb-2"
                      style={{ color: config.color }}
                    >
                      {formatDate(visit.date)}
                    </p>
                    {visit.items && (
                      <div className="flex flex-wrap gap-1.5 mb-2">
                        {visit.items.split(",").map((item, i) => (
                          <span
                            key={i}
                            className="text-xs px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700"
                          >
                            {item.trim()}
                          </span>
                        ))}
                      </div>
                    )}
                    {visit.staff && (
                      <p className="text-xs text-gray-400">
                        with {visit.staff}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-gray-400 py-2">
                No recent visits found.
              </p>
            )}
          </div>
        </div>

        <div className="px-6 pb-6 pt-4 space-y-2">
          <button
            onClick={onContinue}
            className="w-full py-3.5 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-all duration-200 active:scale-[0.98] shadow-lg hover:shadow-xl"
            style={{
              background: `linear-gradient(135deg, ${config.color}, ${config.color}dd)`,
              boxShadow: `0 8px 20px -5px ${config.color}40`,
            }}
          >
            Continue to {service}
            <FaExternalLinkAlt size={12} />
          </button>

          <button
            onClick={onClose}
            className="w-full py-2.5 text-gray-500 font-medium hover:text-gray-700 text-sm transition-colors"
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
};

export default RedirectionModal;
